import { useCachedFetch } from "./useCachedFetch";
import { apiGetMe } from "../services/authService";
import { useAuth } from "../context/AuthContext";

// Thin wrapper around useCachedFetch exposing the profile/role/tier data
// GET /api/auth/me returns alongside the lightweight `user` object AuthContext
// already tracks. Kept separate from AuthContext deliberately — AuthContext's
// session-restore fetch is tuned to avoid unnecessary network calls on a
// valid session, while pages that need fresh profile/access data (Account,
// future Pricing) should fetch it on demand instead.
export function useAccess() {
  const { user } = useAuth();
  const { data, loading, error, retry } = useCachedFetch(() => apiGetMe(), {
    key: user?.id ?? null,
    enabled: Boolean(user),
  });
  return {
    profile: data?.profile ?? null,
    access: data?.access ?? null,
    standing: data?.accountStanding ?? null,
    loading,
    error,
    retry,
  };
}
